<template>
  <div>
    <label style="display: flex; position: relative; align-items: center">
      <ml-input class="w-full h-full" style="border-radius: 5px" :readonly="readonly" :value="selectEmployee ? selectEmployee[intputField] : ''" @click="handleClickInput" />
      <vs-icon v-if="!readonly" icon-pack="feather" icon="icon-users" style="padding-left: 6px; padding-right: 6px; position: absolute; top: auto; right: 0; bottom: auto; font-size: 24px; border-left: 1px solid #cdcdcd"></vs-icon>
    </label>

    <popup-search-employee v-model="showPopup" @handleClickSelect="handleClickSelect" />
  </div>
</template>

<script>
import PopupSearchEmployee from "@/popup/PopupSearchEmployee";

export default {
  name: "EmployeeSelector",
  components: { PopupSearchEmployee },
  props: {
    readonly: Boolean,
    value: Object | null,
    intputField: {
      type: String,
      default: "employee_id",
    },
  },
  data() {
    return {
      showPopup: false,
      selectEmployee: null,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.selectEmployee = value;
      },
    },
    selectEmployee: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    handleClickInput() {
      if (!this.readonly) this.showPopup = true;
    },

    handleClickSelect(employee) {
      if (this.readonly) {
        // 읽기 전용일 때에는 선택 동작으로 넘어가지 않게 핟나
        return;
      }
      this.selectEmployee = employee[0];
      this.$emit("select", employee[0]);
    },
  },
};
</script>

<style scoped></style>
